module.exports = __webpack_public_path__ + "media/0006.834b6314.mp3";